<template>
  <highcharts :options="options" />
</template>

<script>
  export default {
    name: 'Grafico',
    props: {
      type: {
        type: String,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      year: {
        type: Number,
        required: true
      },
      series: {
        type: Array,
        required: true
      }
    },
    computed: {
      categories() {
        switch (this.type) {
          case 'mensal':
            return ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
          case 'trimestral':
            return ['Mar', 'Jun', 'Set', 'Dez'];
          case 'semestral':
            return ['Jun', 'Dez'];
          case 'nonamestral':
            return ['Set', ''];
          case 'anual':
            return [this.year, ''];
          default:
            return [];
        }
      },
      meta() {
        const data = this.series.filter((obj) => obj.kpi == 'Meta').shift();
        return this.getDataSeries(data);
      },
      realizado() {
        const data = this.series.filter((obj) => obj.kpi == 'Realizado').shift();
        return this.getDataSeries(data);
      },
      options() {
        return {
          chart: {
            zoomType: 'xy'
          },
          title: {
            text: this.title
          },
          subtitle: {
            text: null
          },
          credits: false,
          xAxis: [
            {
              categories: this.categories,
              crosshair: true
            }
          ],
          yAxis: [
            {
              labels: {
                format: '{value}%'
              },
              title: {
                text: null
              }
            }
          ],
          tooltip: {
            shared: true
          },
          series: [
            {
              name: 'Meta',
              type: 'line',
              data: this.meta,
              color: 'gray',
              tooltip: {
                valueSuffix: '%'
              }
            },
            {
              name: 'Realizado',
              type: 'column',
              data: this.realizado,
              color: '#faa732',
              tooltip: {
                valueSuffix: '%'
              }
            }
          ]
        };
      }
    },
    methods: {
      getDataSeries(data) {
        let series = [];
        switch (this.type) {
          case 'mensal':
            series = [
              data.jan,
              data.fev,
              data.mar,
              data.abr,
              data.mai,
              data.jun,
              data.jul,
              data.ago,
              data.set,
              data.out,
              data.nov,
              data.dez
            ];
            break;
          case 'trimestral':
            series = [data.mar, data.jun, data.set, data.dez];
            break;
          case 'semestral':
            series = [data.jun, data.dez];
            break;
          case 'nonamestral':
            series = [data.set, data.aux];
            break;
          case 'anual':
            series = [data.dez, data.aux];
        }
        return series.map((item) => Number.parseInt(item * 100));
      }
    }
  };
</script>
